import { useEffect, useRef, useState } from "react";

export const useDropdown = () => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const toggle = () => setOpen(prev => !prev);
    const close = () => setOpen(false);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                close();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return { open, toggle, close, ref };
};
